<span #anchor #toolTip="kendoTooltip" *ngIf="tooltipLabel || (showTooltip && (tooltipName | localizeTooltip))" [position]="tooltipPosition"
  kendoTooltip [title]="tooltipLabel ? tooltipLabel : (tooltipName | localizeTooltip)" class="tooltip cursor-pointer" [class.clicked]="isOpened"
  [tooltipClass]="tooltipClass"
  (click)="toggle(anchor, $event)" showOn="none">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

<span #textAchor *ngIf="!showTooltip && text" #toolTip="kendoTooltip" [title]="tooltipName | localizeTooltip"
  [tooltipClass]="tooltipClass"
  [innerHtml]="text" [position]="tooltipPosition" kendoTooltip [class.clicked]="isOpened"
  (click)="toggle(textAchor, $event)" showOn="none"></span>
